<div class="grid m-0 p-3">
  <div class="col">
    <div class="abas" [class]="abaSelecionada == 1 ? 'aba-ativa' : 'aba-desativada'" (click)="onButtonClick(1)">
      <div class="img mr-2">
        <img [src]="abaSelecionada == 1 ? '/assets/icons/tabler_calculator_orange.svg' : '/assets/icons/tabler_calculator_grey.svg'" alt="imagem de um arquivo">

      </div>

      <span >Maquininha</span>
    </div>

  </div>
  <div class="col">
    <div class="abas" [class]="abaSelecionada == 2 ? 'aba-ativa' : 'aba-desativada'"  (click)="onButtonClick(2)">
      <div class="img mr-2">
        <img [src]="abaSelecionada == 2 ? '/assets/icons/tabler_file-import_orange.svg' : '/assets/icons/tabler_file-import_grey.svg'" alt="imagem de um arquivo">
      </div>
      <span >Emissão de Nota Fiscal </span>
    </div>

  </div>

  <div class="col">
    <div class="abas" [class]="abaSelecionada == 3 ? 'aba-ativa' : 'aba-desativada'" (click)="onButtonClick(3)">
      <div class="img mr-2">
        <img [src]="abaSelecionada == 3 ? '/assets/icons/tabler_bolt_orange.svg' : '/assets/icons/tabler_bolt_grey.svg'" alt="Split Pagamentos">

      </div>
      <span  >Split Pagamentos</span>
    </div>

  </div>
  <div class="col">
    <div class="abas" [class]="abaSelecionada == 4 ? 'aba-ativa' : 'aba-desativada'" (click)="onButtonClick(4)">
      <div class="img mr-2">

        <img [src]="abaSelecionada == 4 ? '/assets/icons/tabler_building-bank_orange.svg' : '/assets/icons/tabler_building-bank_grey.svg'" alt="Bancos não integrados">
      </div>
      <span >Bancos não integrados</span>
    </div>

  </div>

</div>
